












































































import { VacationCarryOverRequestStateEnum } from '@/models';
import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import { IFetchVacationCarryOverRequestsFilterParams } from '@/services';

export default mixins(auth).extend({
  name: 'VacationCarryOverRequestSerachFilter',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as IFetchVacationCarryOverRequestsFilterParams,

      stateList: [
        {
          value: VacationCarryOverRequestStateEnum.Submitted,
          display_name: 'Submitted'
        },

        {
          value: VacationCarryOverRequestStateEnum.Approved,
          display_name: 'Approved'
        },

        {
          value: VacationCarryOverRequestStateEnum.Cancelled,
          display_name: 'Cancelled'
        },

        {
          value: VacationCarryOverRequestStateEnum.Rejected,
          display_name: 'Rejected'
        }
      ]
    };
  },

  computed: {
    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(
      params: IFetchVacationCarryOverRequestsFilterParams
    ) {
      if (params.state != null && !isNaN(params.state)) {
        this.filterParams.state = Number(params.state);
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
